// import CompanyInfoPage from "../pages/CompanyInfoPage";
// import React, { useState } from 'react';

const API_BASE_URL = 'https://trpliveapi1.tripbox.co.kr/WEB/GetDataSet';
const FILE_UPLOAD_URL = 'https://revato.mytripbox.co.kr/itinerary/';
// const FILE_UPLOAD_URL = 'http://127.0.0.1:9001/itinerary/';
const LOGO_UPLOAD_URL = 'https://trpliveapi1.tripbox.co.kr/Upload/uploadS3/';


export interface ApiResponse<T = any> {
  data: T;
  status: number;
  message?: string;
}

export interface ApiRequestBody {
  procedureName: string;
  postData: Array<{
    컬럼명: string;
    값: any | null;
  }>;
}

export interface Itinerary {
  일정번호: number;
  일정명: string;
  상품가: string;
  유효시작일: string;
  유효종료일: string;
  키워드: string;
  엑셀파일경로: string;
  내용: string;
  유저명: string;
  등록일시: string;
  수정일시: string;
  공유: boolean;
}

// URL에 procedureName을 파라미터로 추가하는 함수
const appendProcedureName = (url: string, procedureName: string) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}procedureName=${encodeURIComponent(procedureName)}`;
};

// 토큰이 필요한 API 호출
export async function fetchApi<T>(procedureName: string, postData: ApiRequestBody['postData']): Promise<ApiResponse<T>> {
  const token = localStorage.getItem('token');
  
  if (!token  && procedureName != 'ITN_S_일정표') {
    console.log(procedureName);
    throw new Error('Authentication token not found');
  }

  try {
    const url = appendProcedureName(API_BASE_URL, procedureName);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        Table1: postData
      }),
    });

    if (!response.ok) {
      console.error('API Error:', response.status, response.statusText);
      const errorText = await response.text();
      console.error('Error Response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return {
      data: result,
      status: response.status,
    };
  } catch (error) {
    console.error('API Call Error:', error);
    throw error;
  }
}

// 토큰이 필요없는 API 호출 (회원가입 등)
export async function fetchApiWithoutToken<T>(procedureName: string, postData: ApiRequestBody['postData']): Promise<ApiResponse<T>> {
  try {
    const url = appendProcedureName(API_BASE_URL, procedureName);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        Table1: postData
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return {
      data: result,
      status: response.status,
    };
  } catch (error) {
    console.error('API Error:', error);
    return {
      data: {} as T,
      status: 500,
      message: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
}


// 파일 업로드 API 호출
export async function uploadFile(formData: FormData | File, url: string): Promise<ApiResponse> {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('Authentication token not found');
  }

  try {
    let uploadFormData: FormData;
    
    if (formData instanceof File) {
      uploadFormData = new FormData();
      uploadFormData.append('file', formData);
    } else {
      uploadFormData = formData;
    }

    // companyNo를 URL 쿼리 파라미터로 추가
    const companyNo = formData instanceof FormData ? formData.get('companyNo') : '';
    const urlWithParams = `${FILE_UPLOAD_URL}${url}?companyNo=${companyNo}`;
    
    const response = await fetch(urlWithParams, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: uploadFormData,
    });

    if (!response.ok) {
      throw new Error('File upload failed');
    }

    const data = await response.json();
    return {
      data,
      status: response.status,
    };
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
}

// 파일 업로드 API 호출
export async function uploadBase64Logo(file: File): Promise<ApiResponse> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = (reader.result as string).split(',')[1];
      try {
        const response = await fetch(LOGO_UPLOAD_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({'File': base64, 'FileName': file.name, 'FilePath': 'Logo/' + localStorage.getItem('CompanyNo') + '/'}),
        });

        if (!response.ok) {
          throw new Error('File upload failed');
        }

        const data = await response.json();
        resolve({ data, status: response.status });
      } catch (error) {
        console.error('File upload error:', error);
        reject(error);
      }
    };
    reader.readAsDataURL(file);
  });
}

// 프로필 업로드 API 호출
export async function uploadBase64Profile(file: File): Promise<ApiResponse> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = (reader.result as string).split(',')[1];
      try {
        const response = await fetch(LOGO_UPLOAD_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({'File': base64, 'FileName': file.name, 'FilePath':  localStorage.getItem('CompanyNo') + '/' + 'Profile/' }),
        });

        if (!response.ok) {
          throw new Error('File upload failed');
        }

        const data = await response.json();
        resolve({ data, status: response.status });
      } catch (error) {
        console.error('File upload error:', error);
        reject(error);
      }
    };
    reader.readAsDataURL(file);
  });
}

// 한글 에디터 테이블 데이터 처리 API 호출
export async function uploadTableData(tableData: any[][]): Promise<ApiResponse> {  
  try {
    const response = await fetch(`${FILE_UPLOAD_URL}df`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ tableData }), // 서버가 예상하는 형식으로 변경
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      data,
      status: response.status,
    };
  } catch (error) {
    console.error('Error uploading table data:', error);
    throw error;
  }
}
export async function uploadTable(tableData: string): Promise<ApiResponse> {
  try {
    console.log('Sending table data:', tableData.substring(0, 200) + '...');

    const response = await fetch(`${FILE_UPLOAD_URL}df_cellMerge`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tableData),  // 문자열 데이터를 직접 JSON으로 변환
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Server error response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}\nDetails: ${errorText}`);
    }

    const data = await response.json();
    return {
      status: response.status,
      data,
    };
  } catch (error) {
    console.error('Error uploading table data:', error);
    throw error;
  }
}
// export async function uploadHWP(sData: JSON): Promise<ApiResponse> {
  
//   const urlWithParams = `${FILE_UPLOAD_URL}/df`;
//   // 변환된 데이터를 처리 엔드포인트로 전송
//   const processResponse = await fetch(urlWithParams, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       columns: sData.columns,
//       data: csvData.data
//     }),
//   });


// }